type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

/**
 * OverlayGraphicIcon — two overlapping rounded rectangles conveying a graphic
 * layered over a frame. Used for the "Add Overlay Graphic" transcript action,
 * where the prior plain-square icon read as generic and clashed with the
 * neighboring "Add Photo" image icon.
 */
const OverlayGraphicIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      {/* Back frame — visible top/left "hook" peeking out behind the front */}
      <path
        d="M10 6V4Q10 2.5 8.5 2.5L4 2.5Q2.5 2.5 2.5 4L2.5 8.5Q2.5 10 4 10L6 10"
        stroke={strokeColor}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Front graphic */}
      <rect
        x="6"
        y="6"
        width="7.5"
        height="7.5"
        rx="1.5"
        stroke={strokeColor}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default OverlayGraphicIcon;
